import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";
import logoLDA from "@/assets/logo-horizontal.png";
import tigrinho from "@/assets/tigrinho2.png";
import { VturbPlayer } from "@/components/VturbPlayer";

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 bg-gradient-primary">
        <div className="absolute top-20 left-20 w-96 h-96 bg-primary/30 rounded-full blur-[100px] animate-glow-pulse" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent/20 rounded-full blur-[100px] animate-glow-pulse" style={{ animationDelay: "2s" }} />
      </div>

      <div className="container relative z-10 px-4 py-20 sm:py-0">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="text-center lg:text-left space-y-8 animate-slide-up">
            {/* <div className="inline-block mb-4">
              <img src={logoLDA} alt="LDA - Libertação das Apostas" className="h-24 mx-auto lg:mx-0" />
            </div> */}
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-tight">
              Liberte-se das Apostas.
              <br />
              <span className="bg-gradient-accent bg-clip-text text-transparent">
                Viva Plenamente.
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl">
              Você não nasceu pra viver preso às apostas. 
              Experimente o método que devolve a liberdade de quem já perdeu tudo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
              variant="hero" 
              size="xl" 
              className="group"
              onClick={() => {
                const section = document.getElementById("final-cta");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
              >
                <Play className="mr-2 h-5 w-5 group-hover:scale-110 transition-transform" />
                Quero Me Libertar Agora
              </Button>
              <Button 
                variant="glass" 
                size="xl"   
                onClick={() => {
                  const section = document.getElementById("depoimentos");
                  if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                Ver os depoimentos
              </Button>
            </div>

            <div className="flex items-center gap-8 justify-center lg:justify-start text-sm">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
                <span className="text-muted-foreground">+1.200 vidas transformadas</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
                <span className="text-muted-foreground">Método 100% comprovado</span>
              </div>
            </div>
          </div>

          {/* Right side - Mockup */}
          <div className="relative">
            {/* <div className="relative z-10">
              <img 
                src={tigrinho} 
                alt="App LDA em dispositivos" 
                className="w-full h-auto drop-shadow-2xl"
              />
            </div> */}

            {/* VSL Container */}
            <div className="relative group animate-scale-in">
              {/* Glass card wrapper */}
              <div className="relative backdrop-blur-xl bg-card/40 rounded-2xl p-2 border border-primary/20 hover:border-primary/40 transition-all duration-500 hover:shadow-[0_0_60px_rgba(100,192,242,0.3)]">
                {/* Video placeholder - Replace with actual video embed */}
                <VturbPlayer
                  videoId="vid-693a1386e60256fc461b6131"
                  scriptUrl="https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a1386e60256fc461b6131/v4/player.js"
                  className="relative w-full rounded-xl"
                />
              </div>

              {/* Glow effect */}
              <div className="absolute -inset-4 bg-gradient-radial from-primary/20 via-accent/10 to-transparent blur-3xl -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>

            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-radial from-primary/40 via-accent/20 to-transparent blur-3xl -z-10" />
          </div>
        </div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
};
